export enum SearchType {
  AbOrder = 'Audience Builder Order',
  Attributes = 'Attributes',
  Basic = 'Basic',
  Conditions = 'Conditions',
  CongressionalDistricts = 'Congressional Districts',
  DataSource = 'Data Source',
  Gender = 'Gender',
  HouseOrder = 'House Order',
  IncludeOutOfStateDonor = 'includeOutOfStateDonor',
  ListRentals = 'NLS Order',
  Locations = 'Locations',
  MailCodes = 'Mail Codes',
  Miscellaneous = 'Miscellaneous',
  None = 'None',
  Omits = 'Omit Flags',
  Sequences = 'Sequences',
  Tags = 'Tags',
}
